__turbopack_context__.v({
  "apple": "FvgTxq_apple",
  "apple3": "FvgTxq_apple3",
  "appstore": "FvgTxq_appstore",
  "desktop": "FvgTxq_desktop",
  "download": "FvgTxq_download",
  "download3": "FvgTxq_download3",
  "footerTopDownload": "FvgTxq_footerTopDownload",
  "mobileTablet": "FvgTxq_mobileTablet",
  "play": "FvgTxq_play",
  "play2": "FvgTxq_play2",
  "play6": "FvgTxq_play6",
  "play7": "FvgTxq_play7",
  "pngegg1": "FvgTxq_pngegg1",
  "pngegg2": "FvgTxq_pngegg2",
  "pngegg5": "FvgTxq_pngegg5",
  "qr1": "FvgTxq_qr1",
  "qr2": "FvgTxq_qr2",
  "row2": "FvgTxq_row2",
  "row6": "FvgTxq_row6",
});
